/******************************************************************************
 * Created Date: Tuesday Febuary 15th 2022                                    *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Tue Feb 15 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/InitialValues.js                       *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

const initialValues = {
  name: "",
  nickname: "",
  email: "",
  picture: "",
  roles: [],
  orgs: []
};

export { initialValues };
